import { render, staticRenderFns } from "./AddTeamTaxModal.vue?vue&type=template&id=2b074fe3&scoped=true&"
import script from "./AddTeamTaxModal.vue?vue&type=script&lang=js&"
export * from "./AddTeamTaxModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTeamTaxModal.vue?vue&type=style&index=0&id=2b074fe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b074fe3",
  null
  
)

export default component.exports